import * as React from 'react';
import ReactDOM from 'react-dom';

import styled from 'styled-components';

import { usePortal } from '@crehana/react-hooks';

export const Backdrop = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: black;
  opacity: 0.16;
  z-index: 100;
  height: 100vh;
`;

const BackdropPortal: React.FC<
  React.PropsWithChildren<{ onDismiss: () => void }>
> = ({ onDismiss }) => {
  const target = usePortal('__next');

  return ReactDOM.createPortal(<Backdrop onClick={onDismiss} />, target);
};

export default BackdropPortal;
